module.exports = __webpack_public_path__ + "assets/email.645431dfbc5e4124242fd003a0454844.png";


/*****************
 ** WEBPACK FOOTER
 ** ./img/email.png
 ** module id = 269
 ** module chunks = 0
 **/